import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../../services/api';
import {
  Container, Grid, FormGroup, TextField,
} from '@mui/material';
import * as Yup from 'yup';
import '../styles.css';
import Progress from '../../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../../redux/disable';
import { setLoading } from '../../../redux/loading';
import Success from '../../../components/Snack/Success';
import Error from '../../../components/Snack/Error';
import { useStyles } from '../../../components/Styles';
import GroupButton from '../../../components/Buttons/ButtonGroup';
import AutocompleteField from '../../../components/Inputs/Autocomplete/Autocomplete';
import TextFieldCustom from '../../../components/Inputs/TextField/TextField';
import {
  DatePicker,
  TimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';

function WaterInput() {
  const location = useLocation();
  const [locale, setLocale] = React.useState('pt');
  const [openProgress, setOpenProgress] = useState(false);
  const [ponds, setPonds] = useState([]);
  const [cycles, setCycles] = useState([]);
  const [waterSources, setWaterSources] = useState([]);
  const [selectedDate, handleSelectedDate] = useState(new Date());
  const [selectedHour, handleHourChange] = useState(new Date());
  const [listedCycles, setListedCycles] = useState([]);
  const [ListedWaterSources, setListedWaterSources] = useState([]);
  const [selectedCycle, handleSelectedCycle] = useState(null);
  const [selectedPond, handleSelectedPond] = useState(null);
  const [selectedWaterSource, handleSelectedWaterSource] = useState(null);

  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();
  let data;

  const formik = useFormik({
    initialValues: {
      pond: '',
      cycle: null,
      quantity: '',
      waterSource: null,
      date: '',
    },
    validationSchema: Yup.object({
      quantity: Yup.number()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua a identificação do Ciclo',
        ),
      // .float("O valor deve ser um número"),
      waterSource: Yup.number().required('Campo Obrigatório'),
      date: Yup.date().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      dispatch(setLoading(true));
      selectedDate.setHours(selectedHour.getHours());
      selectedDate.setMinutes(selectedHour.getMinutes());
      values.date = selectedDate.toUTCString();
      request(values);
    },
  });

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.data.id;
        data = location.state.data;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);

    handleSelectedPond(data.cycle.pond);
    handleSelectedCycle(data.cycle);
    handleSelectedWaterSource(data.waterSource);

    handleSelectedDate(new Date(data.date));
    handleHourChange(new Date(data.date));
  }

  useEffect(() => {
    async function load() {
      // carrega o viveiro caso tenha id, do contrario carrega vazio para cadastrar um novo
      setOpenProgress(true);

      const ponds_ = await api.get('/ponds/');
      const waterSources_ = await api.get('/water-sources/');
      const cycles_ = await api.get('/cycles/');

      setPonds(ponds_.data);
      setCycles(cycles_.data);
      setListedCycles(cycles_.data);
      setWaterSources(waterSources_.data);
      setListedWaterSources(waterSources_.data);

      if (id) {
        setListedCycles(
          cycles_.data.filter(
            (cycle) => cycle.pond.id === data.cycle.pond.id,
          ),
        );
        setWaterSources(
          waterSources_.data.filter(
            (waterSource) => waterSource.id === data.waterSource.id,
          ),
        );
      }

      setOpenProgress(false);
    }
    load();
  }, []);

  // carrega o WaterInput caso tenha id, do contrario carrega vazio para cadastrar um novo

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      id
        ? await api.put(`/water-inputs/${id}`, { ...data })
        : await api.post('/water-inputs', { ...data });
      success();
      history.push('/water-inputs');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  return (
    <Container>
      {openProgress ? <Progress /> : null}

      <form onSubmit={formik.handleSubmit}>
        <form className={classes.root}>
          <h2 className="title">Dados de consumo de água</h2>

          <FormGroup>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <AutocompleteField
                  label="Viveiro"
                  data={ponds}
                  value={selectedPond}
                  getOptionLabel="description"
                  // onBlur={formik.handleBlur}
                  onChange={(p, v) => {
                    handleSelectedPond(v);
                    setListedCycles(
                      v
                        ? cycles.filter((cycle) => cycle.pond.id === v.id)
                        : cycles,
                    );
                    handleSelectedCycle(null);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <AutocompleteField
                  label="Ciclo"
                  data={listedCycles}
                  value={selectedCycle}
                  getOptionLabel="description"
                  onChange={(e, v) => {
                    handleSelectedCycle(v);
                    if (v) formik.values.cycle = v.id;
                  }}
                />
              </Grid>
            </Grid>
          </FormGroup>
          <FormGroup>
            <AutocompleteField
              label="Fonte de água"
              data={ListedWaterSources}
              value={selectedWaterSource}
              getOptionLabel="name"
              onChange={(e, v) => {
                handleSelectedWaterSource(v);
                if (v) formik.values.waterSource = v.id;
              }}
            />
          </FormGroup>
          <FormGroup>
            <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    InputLabelProps={{
                      style: { pointerEvents: 'auto' },
                      shrink: true,
                    }}
                    label={<div>Data</div>}
                    variant="inline"
                    inputVariant="outlined"
                    invalidDateMessage="Data Inválida"
                    value={selectedDate}
                    onChange={(date) => {
                      handleSelectedDate(date);
                      formik.setFieldValue('date', date);
                    }}
                    onBlur={formik.handleBlur}
                    format="dd/MM/yyyy"
                    fullWidth
                    error={!!(formik.touched.date && formik.errors.date)}
                    helperText={
                      formik.touched.date
                      && formik.errors.date
                      && formik.errors.date
                    }
                    // inputFormat="DD/MM/YYYY"
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TimePicker
                    InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                    fullWidth
                    variant="inline"
                    inputVariant="outlined"
                    invalidDateMessage="Hora inválida"
                    label={<div>Inserido às (horas)</div>}
                    format="HH:mm"
                    value={selectedHour}
                    onChange={(date) => handleHourChange(date)}
                  />
                </Grid>
              </Grid>
            </LocalizationProvider>
          </FormGroup>

          <FormGroup>
            <TextFieldCustom
              id="Quantidade em litros"
              label="Quantidade em litros"
              type="number"
              formik={formik}
              value={formik.values.quantity}
              errorAndHelper="quantity"
              onChange={(e) => {
                formik.setFieldValue('quantity', parseFloat(e.target.value));
              }}
            />
          </FormGroup>
        </form>

        <GroupButton
          deleteRoute="/water-inputs/"
          routeDelete="/water-inputs"
          returnRoute="/water-inputs"
          id={id}
          disable={disable}
          message="A exclusão dessa mortalidade pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
        />
      </form>
    </Container>
  );
}

export default WaterInput;
